export default __webpack_public_path__ + "static/media/ResellerPortal2.2cd7bf29.png";